import React from "react";

const PoweredByWave = ({ className = "" }) => {
  return (
    <div className={`flex items-center justify-center space-x-2 ${className}`}>
      <span className="text-gray-500 text-sm">Powered by</span>
      <a
        href="https://wave.events"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:opacity-80 transition-opacity duration-200 flex items-center"
      >
        <img
          src="https://staging.cdn.wave.events/logos/black.svg"
          alt="Wave.events"
          className="h-3 flex-shrink-0"
        />
      </a>
    </div>
  );
};

export default PoweredByWave;
